import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const LetterIcon = ({ color }: any) => {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.66406 5.83301L8.46816 10.5959C9.01914 10.9816 9.29463 11.1744 9.59428 11.2491C9.85898 11.3151 10.1358 11.3151 10.4005 11.2491C10.7002 11.1744 10.9757 10.9816 11.5266 10.5959L18.3307 5.83301M5.66406 16.6663H14.3307C15.7309 16.6663 16.4309 16.6663 16.9657 16.3939C17.4361 16.1542 17.8186 15.7717 18.0582 15.3013C18.3307 14.7665 18.3307 14.0665 18.3307 12.6663V7.33301C18.3307 5.93288 18.3307 5.23281 18.0582 4.69803C17.8186 4.22763 17.4361 3.84517 16.9657 3.60549C16.4309 3.33301 15.7309 3.33301 14.3307 3.33301H5.66406C4.26393 3.33301 3.56387 3.33301 3.02909 3.60549C2.55868 3.84517 2.17623 4.22763 1.93655 4.69803C1.66406 5.23281 1.66406 5.93288 1.66406 7.33301V12.6663C1.66406 14.0665 1.66406 14.7665 1.93655 15.3013C2.17623 15.7717 2.55868 16.1542 3.02909 16.3939C3.56387 16.6663 4.26393 16.6663 5.66406 16.6663Z"
          stroke="#C7C9CD"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default LetterIcon;
